import { colors } from '@theme/index'

const styles = {
    container: {
        minHeight: '90vh',
    },
    sebLogo: {
        height: '50px',
        marginBottom: '20px',
    },
    loginWrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '44px',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '25px',
        paddingBottom: '50px',
        paddingTop: '50px',
        width: 500,
        backgroundColor: '#f7f7f7',
        '@media only screen and (min-width:250px) and (max-width:550px)': {
            width: '90%',
        },
    },
    headerText: {
        fontWeight: 500,
        marginBottom: '12px',
    },
    description: {
        marginBottom: '20px',
        textAlign: 'center',
    },
    label: {
        fontWeight: 600,
        marginBottom: '5px',
    },
    loginTypeSelector: {
        maxHeight: 35,
        minWidth: '80%',
        marginBottom: '10px',
    },
    loginButton: {
        marginTop: '12px',
        minWidth: '80%',
    },
    personNumberField: {
        width: '80%',
        marginBottom: '10px',
    },
    loaderWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '3px',
        marginBottom: '2px',
    },
    noteText: {
        marginTop: '20px',
        textAlign: 'center',
        fontWeight: '800',
        lineHeight: '18px',
        color: colors.primary,
    },
}

export default styles
